import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { getStandardInputLabelProps } from '../../utils/muiTextFieldProps';

const EditUser = ({ user: initialUser, submitForm, onClose, currentUser }) => {
    // Check if current user is admin (RoleID === 1)
    const isCurrentUserAdmin = currentUser && currentUser.RoleID === 1;
    
    // Initialize state with normalized user data
    const getInitialUser = () => {
        if (initialUser) {
            return {
                ...initialUser,
                RoleID: initialUser.RoleID !== undefined && initialUser.RoleID !== null ? Number(initialUser.RoleID) : '',
                UserLevel: initialUser.UserLevel !== undefined && initialUser.UserLevel !== null ? Number(initialUser.UserLevel) : ''
            };
        }
        return initialUser;
    };
    
    const [user, setUser] = useState(getInitialUser());
    
    // Update user data when initialUser prop changes
    useEffect(() => {
        if (initialUser) {
            const normalizedUser = {
                ...initialUser,
                RoleID: initialUser.RoleID !== undefined && initialUser.RoleID !== null ? Number(initialUser.RoleID) : '',
                UserLevel: initialUser.UserLevel !== undefined && initialUser.UserLevel !== null ? Number(initialUser.UserLevel) : ''
            };
            setUser(normalizedUser);
        }
    }, [initialUser]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setUser(prev => {
            const newUser = { ...prev, [name]: value };
            return newUser;
        });
    };

    return (
        <div className="modalStyle">
            <div className="innermodal">
                <Card className="cardStyle" style={{ width: '295px' }}>
                    <h2 className='editUser'>Edit User</h2>
                    {!isCurrentUserAdmin && (
                        <div style={{ 
                            padding: '0 16px 16px 16px',
                            fontSize: '14px', 
                            color: '#666', 
                            textAlign: 'center',
                            borderBottom: '1px solid #eee'
                        }}>
                            You can edit your profile information. Role changes require administrator privileges.
                        </div>
                    )}
                    <CardContent>
                        <form style={{ textAlign: 'center' }}>
                            {/* First Name */}
                            <div>
                                <TextField
                                    label="First Name"
                                    name="FirstName"
                                    variant="outlined"
                                    className='inviteUserInput'
                                    value={user.FirstName || ''}
                                    onChange={handleChange}
                                    required
                                    InputLabelProps={getStandardInputLabelProps('#4285f4', Boolean(user.FirstName))}
                                />
                            </div>
                            
                            {/* Last Name */}
                            <div>
                                <TextField
                                    label="Last Name"
                                    name="LastName"
                                    variant="outlined"
                                    className='inviteUserInput'
                                    value={user.LastName || ''}
                                    onChange={handleChange}
                                    required
                                    InputLabelProps={getStandardInputLabelProps('#4285f4', Boolean(user.LastName))}
                                />
                            </div>
                            
                            {/* Title */}
                            <div>
                                <TextField
                                    label="Title"
                                    name="Title"
                                    variant="outlined"
                                    className='inviteUserInput'
                                    value={user.Title || ''}
                                    onChange={handleChange}
                                    required
                                    InputLabelProps={getStandardInputLabelProps('#4285f4', Boolean(user.Title))}
                                />
                            </div>
                            
                            {/* Role ID */}
                            <div>
                                <TextField
                                    label="Role"
                                    name="RoleID"
                                    variant="outlined"
                                    className='inviteUserInput'
                                    value={user.RoleID || ''}
                                    onChange={handleChange}
                                    required
                                    disabled={!isCurrentUserAdmin}
                                    select
                                    InputLabelProps={getStandardInputLabelProps('#4285f4', Boolean(user.RoleID))}
                                    InputProps={{ style: { minWidth: '245px', textAlign: 'left' } }}
                                    SelectProps={{
                                        MenuProps: {
                                            anchorOrigin: { vertical: "bottom", horizontal: "left" }
                                        }
                                    }}
                                >
                                    <MenuItem value="" disabled>Select Role</MenuItem>
                                    <MenuItem value={1}>Admin</MenuItem>
                                    <MenuItem value={2}>User</MenuItem>
                                </TextField>
                                {!isCurrentUserAdmin && (
                                    <div style={{ 
                                        fontSize: '12px', 
                                        color: '#666', 
                                        marginTop: '4px', 
                                        textAlign: 'left',
                                        marginLeft: '4px'
                                    }}>
                                        Only administrators can modify user roles
                                    </div>
                                )}
                            </div>
                            
                            {/* User Level */}
                            <div>
                                <TextField
                                    label="User Level"
                                    name="UserLevel"
                                    variant="outlined"
                                    className='inviteUserInput'
                                    value={user.UserLevel || ''}
                                    onChange={handleChange}
                                    required
                                    select
                                    InputLabelProps={getStandardInputLabelProps('#4285f4', Boolean(user.UserLevel))}
                                    InputProps={{ style: { minWidth: '245px', textAlign: 'left' } }}
                                    SelectProps={{
                                        MenuProps: {
                                            anchorOrigin: { vertical: "bottom", horizontal: "left" }
                                        }
                                    }}
                                >
                                    <MenuItem value="" disabled>Select User Level</MenuItem>
                                    <MenuItem value={1}>Maintainer</MenuItem>
                                    <MenuItem value={2}>Reader</MenuItem>
                                </TextField>
                            </div>
                        </form>
                    </CardContent>
                    <CardActions style={{ justifyContent: 'space-evenly', paddingBottom: '30px' }}>
                        <Button variant="contained" color="primary" onClick={() => submitForm(user)}>
                            Submit
                        </Button>
                        <Button variant="contained" color="secondary" onClick={onClose}>
                            Cancel
                        </Button>
                    </CardActions>
                </Card>
            </div>
        </div>
    );
};

export default EditUser;
